export default __webpack_public_path__ + "static/media/0162.b5c4d1c8.jpg";